// файл Welcome.js

import React, { useState } from 'react';

const Welcome = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Обработчики изменений для полей ввода
  const handleLoginChange = (e) => {
    setLogin(e.target.value);
    setIsSubmitted(false); // Скрыть сообщение при изменении полей
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setIsSubmitted(false); // Скрыть сообщение при изменении полей
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (login && password) {
      setIsSubmitted(true);
      setLogin('');
      setPassword('');
    }
  };

  // Функция для проверки заполненности полей
  const areFieldsEmpty = () => {
    return !login || !password;
  };

  return (
    <div
      style={{
        textAlign: "center",
        margin: "0",
        padding: "0",
        backgroundColor: "#121212", // Тёмный фон для страницы
        color: "#ffffff", // Белый цвет текста
        minHeight: "100vh", // Минимальная высота страницы
        display: "flex", // Центрируем форму по вертикали
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <h1>
        Welcome to{" "}
        <span style={{ color: "#007BFF" }}>Pay</span>
        <span style={{ color: "#ffffff" }}>`</span>
        <span style={{ color: "#E0115F" }}>S</span>erver
      </h1>

      <form onSubmit={handleSubmit} style={{ marginTop: "30px" }}>
        <div style={{ marginBottom: "15px" }}>
          <input
            type="text"
            id="login"
            value={login}
            onChange={handleLoginChange}
            placeholder="Login"
            style={{
              padding: "10px",
              width: "300px",
              borderRadius: "5px",
              border: "1px solid #333", // Тёмная граница
              backgroundColor: "#333", // Тёмный фон для поля ввода
              color: "#fff", // Белый текст в поле
              fontSize: "16px", // Размер шрифта
            }}
          />
        </div>
        <div style={{ marginBottom: "15px" }}>
          <input
            type="password"
            id="password"
            value={password}
            onChange={handlePasswordChange}
            placeholder="Password"
            style={{
              padding: "10px",
              width: "300px",
              borderRadius: "5px",
              border: "1px solid #333", // Тёмная граница
              backgroundColor: "#333", // Тёмный фон для поля ввода
              color: "#fff", // Белый текст в поле
              fontSize: "16px", // Размер шрифта
            }}
          />
        </div>
        <button
          type="submit"
          disabled={areFieldsEmpty()} // Кнопка неактивна, если поля пустые
          style={{
            padding: "10px 20px",
            fontSize: "16px",
            backgroundColor: areFieldsEmpty() ? "#aaaaaa" : "#6200ea", // Цвет кнопки в зависимости от состояния
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: areFieldsEmpty() ? "not-allowed" : "pointer", // Изменение курсора в зависимости от состояния
            marginTop: "10px",
            opacity: areFieldsEmpty() ? 0.6 : 1, // Уменьшаем яркость кнопки, если она неактивна
          }}
        >
          Submit
        </button>
      </form>

      {/* Показать сообщение только если форма успешно отправлена */}
      {isSubmitted && (
        <div style={{ color: "red", marginTop: "20px" }}>
          Wrong login or password. Please try again.
        </div>
      )}
    </div>
  );
};

export default Welcome;